import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Logo from "../Logo.png";

const Navbar = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleConsultationClick = () => {
    // Scroll to quotation section on the page
    window.location.href = "/#quotation";
    setTimeout(() => {
      const section = document.getElementById("quotation");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
    // Close mobile menu if open
    setMobileMenuOpen(false);
  };

  const handleNavigate = (path) => {
    navigate(path);
    // Close mobile menu if open
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className="md:px-20  w-full flex justify-between items-center fixed py-12 h-25 bg-opacity-30 backdrop-blur-xl z-50">
        <div>
        <Link to="/" >

          <img src={Logo} alt="Logo" className="h-50 w-auto" />
            </Link>
        </div>

        <ul className="hidden md:flex space-x-6 text-gray-600 font-medium ml-auto">
          <li>
            <Link to="/" className="hover:text-gray-900 transition text-md">
              Home
            </Link>
          </li>
          <li>
            <Link to="/services" className="hover:text-gray-900 transition text-md">
              Services
            </Link>
          </li>
          <li>
            <Link to="/blogs" className="hover:text-gray-900 transition text-md">
              Blog/Resources
            </Link>
          </li>
          <li>
            <Link to="/contact" className="hover:text-gray-900 transition text-md">
              Contact
            </Link>
          </li>
        </ul>

        <div className="hidden md:flex gap-x-4 ml-10">
          <button
            className="text-gray-900 bg-white border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-full text-sm px-5 py-2 transition"
            onClick={() => handleNavigate("/solar-savings-calculator")}
          >
            Calculate Savings
          </button>
          <button
            className="text-white bg-gray-900 border border-gray-900 hover:bg-gray-800 focus:ring-4 focus:ring-gray-300 font-medium rounded-full text-sm px-5 py-2 transition"
            onClick={handleConsultationClick}
          >
            Free Consultation
          </button>
        </div>

        {/* Hamburger Menu for Mobile */}
        <div className="md:hidden absolute right-5">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-gray-600 hover:text-gray-900 focus:outline-none"
          >
            {mobileMenuOpen ? (
              // Close Icon
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              // Hamburger Icon
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 bg-white z-40 flex flex-col p-6">
          <div className="flex justify-end">
            <button
              onClick={() => setMobileMenuOpen(false)}
              className="text-gray-600 hover:text-gray-900 focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <ul className="flex flex-col space-y-4 mt-8 text-gray-600 font-medium">
            <li className="mt-5">
              <Link
                to="/"
                className="hover:text-gray-900 transition text-md"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-gray-900 transition text-md"
                onClick={() => setMobileMenuOpen(false)}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/blogs"
                className="hover:text-gray-900 transition text-md"
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog/Resources
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-gray-900 transition text-md"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>
            </li>
            <li>
              <button
                className="w-full text-gray-900 bg-white border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-full text-sm px-5 py-3 transition"
                onClick={() => {
                  handleNavigate("/solar-savings-calculator");
                  setMobileMenuOpen(false);
                }}
              >
                Calculate Savings
              </button>
            </li>
            <li>
              <button
                className="w-full text-white bg-gray-900 border border-gray-900 hover:bg-gray-800 focus:ring-4 focus:ring-gray-300 font-medium rounded-full text-sm px-5 py-3 transition"
                onClick={handleConsultationClick}
              >
                Free Consultation
              </button>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default Navbar;
